import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=72dcd738"
import script from "./checkbox-group.vue?vue&type=script&lang=js"
export * from "./checkbox-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports